<template>
  <div class="bg-gray-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-4xl mx-auto">
      <!-- Intro -->
      <div class="text-center mb-6">
        <h1 class="text-3xl font-bold text-gray-800 mb-2">Simple, Transparent Pricing</h1>
        <p class="text-gray-600 max-w-xl mx-auto">
          Whether you're looking for a quick fix or a full build, you'll find fair, transparent pricing below.
        </p>
      </div>

      <!-- Pricing Table -->
      <div class="bg-white p-6 rounded-xl shadow mb-6">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div
            v-for="(service, index) in services"
            :key="index"
            class="border border-gray-100 p-4 rounded-2xl opacity-0 animate-fadeInUp shadow-md hover:shadow-lg transition hover:scale-110"
          >
            <h3 class="text-lg font-semibold text-gray-800 mb-1">{{ service.name }}</h3>
            <p class="text-gray-600 text-sm mb-1">{{ service.note }}</p>
            <p class="text-bright-blue font-bold text-sm">{{ service.price }}</p>
          </div>
        </div>
      </div>

      <!-- Payment Terms -->
      <div class="bg-white p-6 rounded-xl shadow mb-6 fade-in-on-scroll" v-scroll-fade>
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Payment Terms</h2>
        <ul class="list-disc list-inside text-gray-700 space-y-2">
          <li>💵 <strong>50% deposit</strong> required upfront</li>
          <li>🔁 <strong>2 rounds of revisions</strong> included</li>
          <li>⏱️ <strong>Turnaround:</strong> Usually 3–7 days depending on scope</li>
          <li class="flex flex-col items-start space-x-2">
            <div class="flex items-center">
              <strong class="mr-2">💳 Payment Options:</strong> 
              <span class="inline-flex items-center gap-2 ml-1">
                <img :src="paypalLogo" alt="PayPal" class="h-20 w-20" />
              </span>
            </div>
            <div class="text-gray-500 text-sm">
              More payment options (like USDT) coming soon
            </div>
          </li>
        </ul>
      </div>

      <!-- CTA -->
      <div class="text-center fade-in-on-scroll" v-scroll-fade>
        <p class="text-gray-700 mb-4">Not sure what fits your needs?</p>
        <a
          href="https://t.me/egbertjoel"
          target="_blank"
          class="inline-block bg-black hover:bg-gray-800 text-white font-semibold px-6 py-2 rounded-lg transition"
        >
          Message Me on Telegram
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import paypalLogo from "@/assets/paypal-logo.svg";

export default {
  name: "PricingPage",
  data() {
    return {
      paypalLogo,
      services: [
        {
          name: "Custom Strategy Automation",
          price: "From $100",
          note: "Automate manual or rule-based strategies into full MT5 Expert Advisors",
        },
        {
          name: "Indicator ↔ EA Conversion",
          price: "From $70",
          note: "Turn indicators into EAs or EAs into visual indicators, alerts included",
        },
        {
          name: "EA Debugging & Optimization",
          price: "$40/hour",
          note: "Fix bugs, improve performance, or refactor your EA",
        },
        {
          name: "Telegram/Email Alert Systems",
          price: "From $60",
          note: "Receive real-time alerts based on custom trading conditions",
        },
        {
          name: "Pine Script ↔ MQL5 Conversion",
          price: "From $80",
          note: "Convert TradingView Pine Script to MQL5 or vice versa",
        },
        {
          name: "Dashboards & Visual Tools",
          price: "From $120",
          note: "Trade panels, strategy testers, overlays, or dashboards in MT5",
        },
        {
          name: "1-on-1 Consultation",
          price: "$25/session",
          note: "Need feedback or guidance? Let's talk strategy and code",
        },
      ],
    };
  },
};
</script>
